import { render, staticRenderFns } from "./AttributeEditForm.vue?vue&type=template&id=21a20266&"
import script from "./AttributeEditForm.vue?vue&type=script&lang=js&"
export * from "./AttributeEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports